export default function Line({ className }: { className?: string }) {
  return (
    <svg
      width="102"
      height="2"
      viewBox="0 0 102 2"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Line</title>
      <path
        d="M1 1H101"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="5 5"
      />
    </svg>
  );
}
